import TagManager from "react-gtm-module";
import config from "~/config";

const gtmId = config.GTM_ID as string;

export const initializeTagManager = () => {
  TagManager.initialize({ gtmId });
};
